import { stringify } from 'query-string';

import { entityTypeToApiType } from 'helpers/mapEntityTypes';

import { TopicFilterNames } from 'components/TopicFilters/shared';
import { EntityTypes } from 'context/entityContext';
import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';

interface IStreamingKPIURLArgs {
  countryIds?: string[];
  customerFilter?: TopicFilterNames[];
  download?: boolean;
  entityType: EntityTypes;
  entityIds: string[];
  userData?: boolean;
  mediaTypes?: string;
  region?: string;
  compareMode?: boolean;
  customRegion?: string | string[];
}

export default function getStreamingKPIURL(args: IStreamingKPIURLArgs): string {
  const {
    countryIds,
    customerFilter,
    download,
    entityType,
    entityIds,
    userData,
    mediaTypes,
    region,
    compareMode,
    customRegion,
  } = args;
  const type = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    customerFilter,
    download,
    userData,
    mediaTypes,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
  });

  return `/api/streaming/kpi/${type}/${entityIds}?${params}`;
}
